import { fetchApi } from '@/config/axiosSetting';
import {
  SingleSubstitutionPartsListParams,
  SingleSubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSingleSubstitutionPartsList/getSingleSubstitutionPartsListQuery.type';

export const getSingleSubstitutionPartsListQueryFunction = (
  params: SingleSubstitutionPartsListParams,
): Promise<SingleSubstitutionPartsListResponse> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/adjusting/substitution_parts/`,
    {
      params,
    },
  );
